import { get } from 'lodash'

export const getCityName = (userCity, defaultCityName) => get(userCity, 'name', defaultCityName)

export const getCityId = (userCity, postalCode) => (postalCode ? 0 : get(userCity, 'id', 0))
